var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Little Bobby")]),_vm._l((_vm.examples),function(example,index){return _c('div',{key:index,staticClass:"p-lg mb-xxl bg-whiteOverride rounded-sm"},[_c('h2',[_vm._v(_vm._s(example.header))]),_c('DataTable',{attrs:{"columns":example.columns,"rows":example.rows}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }